import React from 'react';
import { useNavMenu } from 'components/nav/context';
import { Notification, NotificationType } from 'components/alerts/notifications/Notification';
import { NotificationDataType } from 'hooks/useNotifications';
import { useIsScripware } from 'hooks/useIsScripware';
import { ReactComponent as NotificationBell } from '../../../../media/images/notif-bell.svg';

interface PendingOrderNotificationProps {
    notification: NotificationDataType;
}
export const PendingOrderNotification = ({ notification }: PendingOrderNotificationProps) => {
    const { title, subtitle, actionName, action } = notification;
    const isScripware = useIsScripware();

    return (
        <div>
            <Notification
                title={title}
                subtitle={subtitle}
                type={NotificationType.INFO}
                buttonTitle={actionName}
                buttonAction={() => action({ isScripware })}
            />
        </div>
    );
};

export const Notifications = () => {
    const { notifications } = useNavMenu();

    if (!notifications.hasNotifications) {
        return null;
    }

    return (
        <div>
            <div className="mb-2.5 text-sm flex gap-2">
                Notifications
                {notifications.hasNotifications && <NotificationBell width="15px" />}
            </div>
            <div className="flex flex-col gap-3 mb-5">
                {notifications.notifications.map((notification: NotificationDataType) => (
                    <PendingOrderNotification
                        key={notification.title}
                        notification={notification}
                    />
                ))}
            </div>
        </div>
    );
};
